<template>
  <li class="nav-item dropdown user-name">
    <a
      class="nav-link dropdown-toggle d-none  d-none d-sm-block"
      href="#"
      role="button"
      @click="open()"
    >
      <label>{{ profile.name }}</label>
      <img class="rounded-circle user-image" :src="primaryImageUrl" />
    </a>
    <i
      class=" nav-link d-sm-none fas fa-bars text-white"
      @click="open()"
      role="button"
    ></i>
    <div
      v-if="!close"
      class="dropdown-menu dropdown-menu-right bg-primary m-0 p-0 d-block"
    >
      <customer-menu
        :profile-name="profile.name"
        :profile-balance="profile.balance"
        class="navbar-dropdown"
      ></customer-menu>
      <div class="navbar-dropdown">
        <div class="dropdown-divider p-0 m-0 d-lg-none"></div>
        <a class="dropdown-item pl-3 m-0" href="#"><Logout></Logout></a>
      </div>
    </div>
  </li>
</template>

<script lang="babel">
export default {
  data () {
    return {
      close: true,
    }
  },
  computed: {
    primaryImageUrl() {
      return `${this.profile.primary_image.url}?width=45&height=45`;
    }
  },
  methods: {
    open () {
      this.close = !this.close;
    }
  },
  mounted () {
    document.body.addEventListener('click', (event) => {
      if(event.target.parentElement && (
        !(event.target.parentElement.classList.contains('dropdown-toggle')||
        event.target.parentElement.classList.contains('dropdown')))
      ){
        this.close =true;
      }
    });
  },
  props: {
    profile: {
      type: Object,
      required: true
    },
  }
};
</script>
